import React from "react";
import { Link } from "react-router-dom";

const wrapperBlog = [
  {
    icon: "flaticon-responsibility",
    title: "Energy",
    content: "Driving innovation with clean and sustainable energy solutions",
  },
  {
    icon: "flaticon-open-book",
    title: "Education",
    content: "Inspiring growth and learning with innovative approaches",
  },
  {
    title: "Technology",
    icon: "flaticon-vr-glasses",
    content: "Empowering progress with advanced technological solutions",
  },
  {
    icon: "flaticon-doctor-bag",
    title: "Health",
    content: "Enhancing well-being with innovative health and care solutions",
  },
];

const CategoriesIcon = () => {
  return (
    <>
      {wrapperBlog.map((item, index) => (
        <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
          <div className="icon-bx-wraper style-1 text-center m-b30">
            <div className="icon-lg m-b30">
              {" "}
              <Link to={"/project"} className="icon-cell">
                <i className={item.icon}></i>
              </Link>{" "}
            </div>
            <div className="icon-content">
              <h5 className="dz-tilte text-capitalize">
                <Link to={"/project"}>{item.title}</Link>
              </h5>
              <p>{item.content}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CategoriesIcon;
